<template>
  <div :class="{ 'comp-fh-list-skeleton': true, 'no-animation': !isShowSkeleton }">
    <template v-for="i in rows" :key="i">
      <div class="table-skeleton-all">
        <div class="table-skeleton-item" v-for="item in columns" :key="item"></div>
      </div>
    </template>
  </div>
</template>
<script setup>
import { onUnmounted, ref } from 'vue';

const props = defineProps({
  rows: {
    type: Number,
    default: 15
  },
  columns: {
    type: Number,
    default: 10
  }
});
console.log(props);

const isShowSkeleton = ref(true);
onUnmounted(() => {
  isShowSkeleton.value = false;
});
</script>
<style scoped lang="less">
@import './fh-list-skeleton.less';
</style>
